import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=7b2ec14b&scoped=true&"
import script from "./Destroy.vue?vue&type=script&lang=js&"
export * from "./Destroy.vue?vue&type=script&lang=js&"
import style0 from "./Destroy.vue?vue&type=style&index=0&id=7b2ec14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ec14b",
  null
  
)

export default component.exports